import { useLocaleStore } from '~/stores/locale'

const BASE = 'https://su-media.s3.amazonaws.com/media/Website_PDFs'

export const usePoliciesUrl = () => {
  const localeStore = useLocaleStore()

  const policiesUrl = computed(() => {
    const culture = localeStore.culture.toLowerCase()

    // FR-CA must be checked before generic FR
    if (culture === 'fr-ca') { return `${BASE}/DEMONSTRATOR_POLICIES_NA-FR.pdf` }

    // DE cultures: DE, AT, BE-DE
    if (culture.startsWith('de')) { return `${BASE}/DEMONSTRATOR_POLICIES_EU-DE.pdf` }

    // FR cultures: FR, BE-FR
    if (culture.startsWith('fr')) { return `${BASE}/DEMONSTRATOR_POLICIES_EU-FR.pdf` }

    // NL cultures: NL, BE (nl-be)
    if (culture.startsWith('nl')) { return `${BASE}/DEMONSTRATOR_POLICIES_EU-NL.pdf` }

    // AU, NZ
    if (culture === 'en-au' || culture === 'en-nz') { return `${BASE}/DEMONSTRATOR_POLICIES_SP-EN.pdf` }

    // UK, IE
    if (culture === 'en-gb' || culture === 'en-ie') { return `${BASE}/DEMONSTRATOR_POLICIES_EU-EN.pdf` }

    // NA English: US, CA (en-ca)
    return `${BASE}/DEMONSTRATOR_POLICIES_NA-EN.pdf`
  })

  return { policiesUrl }
}
